import {
  ContestTeamBasic,
  ContestTypes
} from '@maxpreps/apiserviceclients/apiModels';
import { CONTEST_TYPE_FORM_OPTIONS } from '../../constants/contestTypes';
import { HOME_AWAY_TYPE_CONFIG } from '../../constants/homeAwayType';

export const getContestTypeText = (
  typeValue: ContestTypes,
  leagueAlias = 'Conference'
): string => {
  const type = CONTEST_TYPE_FORM_OPTIONS.find(v => v.value === typeValue);
  if (!type) return '';
  return type.label.replace('Conference', leagueAlias);
};

export const getHomeAwayText = (
  homeAwayState: any,
  shortForm = false
): string => {
  // this is hedious but what a would be required because of reverse mapping.
  // because of this, i'm skipping the 'find enum' step and using the value passed in to go straight to the map
  // https://www.tutorialsteacher.com/typescript/typescript-enum
  // const type = homeAwayTypesMap.get(HomeAwayType[HomeAwayType[homeAwayState]]);
  const type = HOME_AWAY_TYPE_CONFIG.get(homeAwayState);
  if (!type) return '';
  return shortForm ? type.shortLabel : type.label;
};

export const getCurrentAndOpponentTeams = (
  teams: ContestTeamBasic[],
  contextualTeamId: string,
  calculatedTeams: any[] = [],
  idProp = 'teamId'
) => {
  const teamId = contextualTeamId ?? calculatedTeams[0][idProp];

  const currentTeam = teams.find(t => t[idProp] === teamId);
  const opponentTeam = teams.find(t => t[idProp] !== teamId);

  const calculatedCurrentTeam = calculatedTeams.find(t => t[idProp] === teamId);
  const calculatedOpponentTeam = calculatedTeams.find(
    t => t[idProp] !== teamId
  );
  return {
    currentTeam: { ...currentTeam, ...calculatedCurrentTeam },
    opponentTeam: { ...opponentTeam, ...calculatedOpponentTeam }
  };
};
